import React, { useEffect, useRef } from 'react';
import { shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'redux-state/configure-store';
import { getWindow } from 'utilities/window';

/** Manages Updating of Nielsen Tracking sends whenever new url is sent */
export const NielsenTrackerHook = ({ children }: { children: React.ReactNode }): React.ReactNode => {
  const currentUrl = useLocation().pathname;
  const screenMeta = useAppSelector((state) => state.LAYOUT.screen.metadata, shallowEqual);
  const screenMetaRef = useRef(screenMeta);

  useEffect(() => {
    screenMetaRef.current = screenMeta;
  }, [screenMeta]);

  useEffect(() => {
    if (Object.keys(screenMetaRef.current).length) {
      /** Metadata exists so record page navigation */
      getWindow()?.nielsenQueue.set();
    }
  }, [currentUrl]);

  return children;
};
